var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:{'active':_vm.isActive},on:{"click":function($event){return _vm.clickItem(_vm.item)}}},[_vm._v(_vm._s(_vm.item.name || _vm.item))])
}
var staticRenderFns = []

export { render, staticRenderFns }